import { ObservableFromFetch } from "../ObservableFromFetch"
import { OnTrackReportType } from "./OnTrackReport"

export interface ReportParameters {
  reportType: OnTrackReportType
  fromDate?: string
  toDate?: string
  accountID?: number
  groupID?: number
  personID?: number
}

export function GovReportsObservable(parameters: ReportParameters) {
  const requestBody: string = JSON.stringify(parameters)

  return ObservableFromFetch<string>("Report/OnTrackGetReport", requestBody)
}
